import { render } from "./CollectionsHoldAlert.vue?vue&type=template&id=15c820ee"
import script from "./CollectionsHoldAlert.vue?vue&type=script&lang=js"
export * from "./CollectionsHoldAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__